import { PropsWithChildren, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";

import Banner from "@components/banners/Banner";
import AppPageWithMenu from "@components/pageTypes/AppPageWithMenu";
import styles from "@components/pageTypes/Page.module.css";
import ProfileDropdown from "@components/ProfileDropdown";
import { bannerContext } from "@context/Contexts";
import useMyClient from "@hooks/useMyClient";

type Props = PropsWithChildren<{
  gradient?: boolean;
  helmetKey: string;
  hideDropdown?: boolean;
  journeyId: string;
  mobileSmallPadding?: boolean;
  noPadding?: boolean;
  stickyHeader?: boolean;
}>;

const ClientPage = ({
  children,
  gradient = true,
  helmetKey,
  hideDropdown = false,
  journeyId,
  mobileSmallPadding = false,
  noPadding = false,
  stickyHeader = false
}: Props) => {
  const intl = useIntl();
  const { currentBanner } = useContext(bannerContext);
  const myClient = useMyClient();

  const queryParams = new URLSearchParams(location.search);

  const hideMenu = queryParams.has("hideMenu");

  return (
    <AppPageWithMenu journeyId={journeyId}>
      <div className={gradient ? styles.background : ""}>
        <Helmet>
          <title>{intl.formatMessage({ id: helmetKey })}</title>
        </Helmet>
        {currentBanner && !hideMenu && (
          <div className={stickyHeader ? styles.stickyBanner : ""}>
            <Banner banner={currentBanner} />
          </div>
        )}
        <div className={mobileSmallPadding || noPadding ? styles.selectorContainerNoPadding : styles.selectorContainer}>
          <div
            className={
              stickyHeader && currentBanner
                ? styles.stickyAccountSelectorWithBanner
                : stickyHeader
                  ? styles.stickyAccountSelector
                  : ""
            }
          >
            {myClient && !hideDropdown && <ProfileDropdown clientId={myClient.id} journeyId={journeyId} />}
          </div>

          <div className={noPadding ? "" : styles.pageContainerNoPadding}>
            <div
              className={
                mobileSmallPadding ? styles.pageContentSmallMobile : noPadding ? "" : styles.pageContentNoTitle
              }
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </AppPageWithMenu>
  );
};

export default ClientPage;
